export default (value) => {
  if (value == null) {
    return 'n/a'
  } else {
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value)
  }
}
